import i18n from '../language';

export const getTranslatedErrorMsg = (errorMsg) => {
    if (errorMsg) {
        errorMsg = errorMsg.replace(/Value cannot be null/gi, i18n.t('responseErrors.valueCannotBeNull'));
        errorMsg = errorMsg.replace(/Parameter name/gi, i18n.t('responseErrors.parameterName'));
        errorMsg = errorMsg.replace(/Object reference not set to an instance of an object/gi, i18n.t('responseErrors.objectReference'));
        errorMsg = errorMsg.replace(/No event data to sync/gi, i18n.t('responseErrors.noEventDateToSync'));
        errorMsg = errorMsg.replace(/No event data to sync/gi, i18n.t('responseErrors.noEventDateToSync'));
        errorMsg = errorMsg.replace(/Cannot read property 'status' of undefined/gi, i18n.t('responseErrors.statusOfUndefined'));
    }

    return errorMsg;
};

export const translateError = (error) => {
    if (!error) {
        return;
    }

    let stringConstructor = 'string'.constructor;
    if (error.constructor === stringConstructor) {
        try {
            error = JSON.parse(error)
        } catch (e) {
            return;
        }
    }

    if (error.response) {
        if (error.response.data && error.response.data.message) {
            error.response.data.message = getTranslatedErrorMsg(error.response.data.message);
            return;
        }

        if (error.response.statusText) {
            error.response.statusText = getTranslatedErrorMsg(error.response.statusText);
            return;
        }
    } 

    if (error.message) {
        error.message = getTranslatedErrorMsg(error.message );
    }

    return;
};

export default {
    translateError,
    getTranslatedErrorMsg
}
